// src/modules/app-views/crm/pages/Document/actions/removeButton.js

import { DeleteOutlined } from '@ant-design/icons';

const crmDocumentRemoveButton = () => {
  return {
    action: 'remove',
    icon: <DeleteOutlined />,
    tooltip: 'remove',
    type: 'default',
  };
};

export default crmDocumentRemoveButton;
